<template>
  <div class="agent_show">
    <div class="base_setting">
      <div class="setting_title">基本设置</div>
      <a-form :hideRequiredMark="true">
        <a-form-item
          label="自定义域名"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input
            :readonly="true"
            class="domain_name"
            placeholder="二级域名，建议3-6位字母"
            v-model="edit.host"
            addon-before="http://"
            :addon-after="baseUrl"
          />
          <span
            @click="copyHost"
            style="color:#1890ff;margin-left:8px;cursor: pointer;"
            >点击复制</span
          >
        </a-form-item>
        <a-form-item
          label="公司名称"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input
            class="input_width"
            placeholder="请输入公司名称"
            v-model="edit.companyName"
          />
        </a-form-item>
        <a-form-item
          label="网站名称"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input
            class="input_width"
            placeholder="请输入网站名称"
            v-model="edit.systemTitle"
          />
        </a-form-item>
        <a-form-item
          label="网站logo："
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-upload
            :multiple="false"
            :showUploadList="false"
            list-type="picture"
            :customRequest="customRequest"
            accept="image/gif, image/png, image/jpeg, image/webp"
          >
            <img
              v-if="preview.image"
              :src="preview.image"
              class="priview_image"
            />
            <div v-else class="picture_upload">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
            <div
              style="color:#1890ff;text-align:center;cursor: pointer;margin-top:8px"
            >
              点击修改
            </div>
          </a-upload>
        </a-form-item>
      </a-form>
    </div>
    <div class="commission_setting">
      <div class="setting_title">
        提成设置
        <div class="extension_desc">
          * 推广下级开通分站，可得
          <span class="extension_money">￥{{ agentLevel.inviter }}元</span
          >佣金，并且可享受该分站销售订单的永久提成
        </div>
      </div>
      <a-form :hideRequiredMark="true">
        <a-form-item
          label="卖出加价"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input-number
            :min="0"
            :precision="2"
            class="input_width"
            placeholder="卖出加价"
            v-model="edit.sell"
          />
          <a-tooltip placement="right">
            <template slot="title">
              <span
                >在你成本的基础上加价，例如：成本2元/单，加价0.3，那么售价就是2.3元/单</span
              >
            </template>
            <a-icon type="question-circle" class="icon" />
          </a-tooltip>
        </a-form-item>

        <a-form-item
          label="成本价"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input-number
            :min="0"
            :precision="2"
            class="input_width"
            placeholder="请输入"
            v-model="edit.plus"
          />
        </a-form-item>

        <a-form-item
          label="下级分站加价"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input-number
            :min="0"
            :precision="2"
            class="input_width"
            placeholder="请输入"
            v-model="edit.part"
          />
          <a-tooltip placement="right">
            <template slot="title">
              <span
                >在你分站的基础上，给推广的分站设置成本价,例如：你是2元/单，加价0.3，这个分站每卖出1单，你就有0.3元的佣金</span
              >
            </template>
            <a-icon type="question-circle" class="icon" />
          </a-tooltip>
        </a-form-item>

        <a-form-item
          label="用户推广提成"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input-number
            :min="0"
            :precision="2"
            class="input_width"
            placeholder="请输入"
            v-model="edit.inviter"
          />
          <a-tooltip placement="right">
            <template slot="title">
              <span
                >B用户通过A用户的推广链接下单，A用户可以拿到你设置的推广提成，这个提成佣金从你的利润里扣除</span
              >
            </template>
            <a-icon type="question-circle" class="icon" />
          </a-tooltip>
        </a-form-item>

        <a-form-item
          label="商品加价"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input-number
            :min="0"
            :precision="2"
            class="input_width"
            placeholder="请输入"
            v-model="edit.goodsPart"
          />
        </a-form-item>
      </a-form>
    </div>
    <div class="service_setting">
      <div class="setting_title">客服设置</div>
      <a-form :hideRequiredMark="true">
        <a-form-item
          label="QQ客服"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-input
            class="input_width"
            placeholder="请输入QQ号码"
            v-model="edit.qq"
          />
        </a-form-item>
        <a-form-item
          label="微信客服"
          :labelCol="{ lg: { span: 2 }, sm: { span: 24 }, md: { span: 24 } }"
          :wrapperCol="{ lg: { span: 8 }, sm: { span: 8 } }"
        >
          <a-upload
            :multiple="false"
            :showUploadList="false"
            listType="picture"
            :customRequest="customRequestWechat"
            accept="image/gif, image/png, image/jpeg, image/webp"
          >
            <img
              v-if="preview.wechat"
              :src="preview.wechat"
              class="priview_image"
            />
            <div v-else class="picture_upload">
              <a-icon type="plus" />
              <div class="ant-upload-text">上传图片</div>
            </div>
            <div
              style="color:#1890ff;text-align:center;cursor: pointer;margin-top:8px"
            >
              点击修改
            </div>
          </a-upload>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { filePreUpload, uploadOSS, agentLevelAll } from "@api";
import { uuid } from "@/utils/util";
export default {
  data() {
    return {
      baseUrl: ".lipw.cn",
      preview: { wechat: "", image: "", show: false },
      edit: {}, // 站点配置
      agentLevel: {} // 开通代理
    };
  },
  created() {
    agentLevelAll().then(result => {
      if (result.success) {
        this.agentLevel = result.data[0];
      } else {
        this.$message.error(result.msg);
      }
    });
  },
  methods: {
    // 复制域名
    copyHost() {
      this.copyInfo("http://" + this.edit.host + this.baseUrl);
    },
    commit() {
      if (!/^[0-9a-zA-Z]*$/.test(this.edit.host) || !this.edit.host) {
        this.$message.error("域名格式错误,请输入数字或字母");
        return;
      }
      if (!this.edit.companyName) {
        this.$message.error("请输入公司名称");
        return;
      }
      if (!this.edit.systemTitle) {
        this.$message.error("请输入系统标题");
        return;
      }
      if (this.edit.sell === undefined) {
        this.$message.error("请设置卖出价");
        return;
      }
      if (this.edit.inviter === undefined) {
        this.$message.error("请设置推广固定金额");
        return;
      }
      const edit = JSON.parse(JSON.stringify(this.edit));
      // if (edit.sell <= 0) {
      //   return this.$message.error('卖出加价必须大于0');
      // }
      if (edit.sell < edit.inviter) {
        this.$message.error("卖出价需要大于用户推广提成");
        return;
      }
      edit.type = 1;
      edit.loginTitle = edit.systemTitle;
      edit.siteTitle = edit.systemTitle;
      edit.logo = this.preview.image;
      edit.wechat = this.preview.wechat;
      // 本地强制修改为localhost:8000
      if (edit.host == "localhost:8000") {
        edit.host = "localhost:8000";
      } else {
        edit.host = edit.host + this.baseUrl;
      }
      return JSON.parse(JSON.stringify(edit));
    },
    customRequest(fileData) {
      // TODO 1 上传到OSS
      filePreUpload()
        .then(response => {
          const data = response.data;
          const url = data.url;
          const prefix = data.key;
          delete data.url;
          delete data.key;
          const array = fileData.file.name.replace(" ", "").split("."); // 把文件名数组化
          let suffix = ""; // 后缀
          if (array.length > 1) {
            suffix = `.${array.pop().toLowerCase()}`;
          }
          const formData = new FormData();
          Object.keys(data).forEach(it => {
            formData.append(it, data[it]);
          });
          const key = `${prefix}/${uuid()}${suffix}`; // 图片访问路径
          formData.append("key", key);
          formData.append("file", fileData.file);
          uploadOSS(url, formData)
            .then(response => {
              // 上传成功，设置图片访问路径
              this.preview.image =
                "http://czkj-cache.oss-cn-shenzhen.aliyuncs.com/" + key;
              this.$message.success("上传成功.");
              return fileData.onSuccess(); // 上传成功了
            })
            .catch(error => {
              this.$message.error("上传异常." + error);
              return fileData.onError(); // 拒绝上传操作
            });
        })
        .catch(error => {
          this.$message.error("授权异常." + error);
          return fileData.onError(); // 拒绝上传操作
        });
    },
    customRequestWechat(fileData) {
      // TODO 1 上传到OSS
      filePreUpload()
        .then(response => {
          const data = response.data;
          const url = data.url;
          const prefix = data.key;
          delete data.url;
          delete data.key;
          const array = fileData.file.name.replace(" ", "").split("."); // 把文件名数组化
          let suffix = ""; // 后缀
          if (array.length > 1) {
            suffix = `.${array.pop().toLowerCase()}`;
          }
          const formData = new FormData();
          Object.keys(data).forEach(it => {
            formData.append(it, data[it]);
          });
          const key = `${prefix}/${uuid()}${suffix}`; // 图片访问路径
          formData.append("key", key);
          formData.append("file", fileData.file);
          uploadOSS(url, formData)
            .then(response => {
              // 上传成功，设置图片访问路径
              this.preview.wechat =
                "http://czkj-cache.oss-cn-shenzhen.aliyuncs.com/" + key;
              this.$message.success("上传成功.");
              return fileData.onSuccess(); // 上传成功了
            })
            .catch(error => {
              this.$message.error("上传异常." + error);
              return fileData.onError(); // 拒绝上传操作
            });
        })
        .catch(error => {
          this.$message.error("授权异常." + error);
          return fileData.onError(); // 拒绝上传操作
        });
    }
  }
};
</script>

<style lang="less" scoped>
.agent_show {
  overflow: hidden;
  font-family: PingFang SC;
  .base_setting {
    margin-bottom: 40px;
  }

  .setting_title {
    display: flex;
    align-items: center;

    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
    margin-bottom: 24px;
  }
  .picture_upload {
    cursor: pointer;
    width: 104px;
    height: 104px;
    border: 1px dashed rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .ant-upload-text {
      margin-top: 12px;
      color: #1890ff;
    }
  }
  .domain_name {
    width: 424px;
  }
  .priview_image {
    width: 104px;
    height: 104px;
    cursor: pointer;
    margin-bottom: 8px;
  }
  .extension_desc {
    height: 100%;
    margin-left: 32px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }
  .extension_money {
    color: #1890ff;
  }
  .input_width {
    width: 240px;
    margin-right: 8px;
  }
  .icon {
    color: #1890ff;
  }
  .setting_btn {
    margin-left: 132px;
    // margin-bottom: 64px;
  }
}
.agent_noshow {
  padding-top: 44px;
  padding-left: 56px;

  box-shadow: 0px 2px 20px rgba(15, 41, 131, 0.1);
  background-color: #fff;
  background-image: url("~@/assets/agent_bg.png");
  background-position: left bottom;
  background-repeat: no-repeat;
  font-family: PingFang SC;
  .agent_no {
    padding-bottom: 68px;
    .agent_title {
      font-size: 20px;
      margin-bottom: 16px;
      color: rgba(0, 0, 0, 0.85);
    }

    .agent_subtitle {
      margin-bottom: 56px;
      color: #1890ff;
    }

    .agent_advantage {
      margin-bottom: 32px;
      .agent_advantage_title {
        margin-bottom: 24px;
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
      }

      .agent_all_item {
        display: flex;
        flex-wrap: wrap;

        .item_one {
          margin-bottom: 24px;
          width: 332px;
          margin-right: 64px;
          display: flex;
          align-items: center;
          span {
            color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            margin-left: 8px;
          }
        }
        .img {
          width: 24px;
          height: 24px;
        }
        .img1 {
          background: url("~@/assets/css_sprites.png") -590px -478px;
        }
        .img2 {
          background: url("~@/assets/css_sprites.png") -590px -522px;
        }
        .img3 {
          background: url("~@/assets/css_sprites.png") -430px -466px;
        }
        .img4 {
          background: url("~@/assets/css_sprites.png") -474px -466px;
        }
        .img5 {
          background: url("~@/assets/css_sprites.png") -518px -466px;
        }
        .img6 {
          background: url("~@/assets/css_sprites.png") -10px -570px;
        }
        .img7 {
          background: url("~@/assets/css_sprites.png") -54px -570px;
        }
        .img8 {
          background: url("~@/assets/css_sprites.png") -98px -570px;
        }
      }
    }

    .agent_step_title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      margin-bottom: 24px;
    }

    .agent_step {
      width: 1224px;
      border-radius: 4px;
      border: 1px dashed #1890ff;
      display: flex;
      margin-bottom: 24px;
      padding: 32px 32px 0;
      .step_item {
        display: flex;
        margin-bottom: 32px;
        margin-right: 22px;

        .item_left {
          width: 140px;
          margin-right: 22px;
          .item_title {
            margin-bottom: 16px;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
          }
          .col {
            color: #1890ff;
          }
          .item_desc {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.45);
          }
        }
        .item_right {
          margin-top: 50px;
          width: 20px;
          height: 8px;
          background: url("~@/assets/css_sprites.png") -539px -570px;
        }
      }
    }

    .step_button {
      margin-bottom: 16px;
      width: 268px;
      height: 56px;
    }

    .agent_desc {
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
    }
  }
}
</style>
